import React, { useState, useEffect, useRef } from "react";

const WithIntersectionObserver = (WrappedComponent) => {
  return (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            setIsVisible(true);
            observer.unobserve(ref.current); // Stop observing after the animation starts
          }
        },
        {
          threshold: 0.7, // Trigger when 50% of the component is in view
        },
      );

      if (ref.current) {
        observer.observe(ref.current);
      }

      return () => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      };
    }, []);

    return <div ref={ref}><WrappedComponent {...props} isVisible={isVisible} /></div>;
  };
};

export default WithIntersectionObserver;



// WEBPACK FOOTER //
// ./src/js/hocs/WithIntersectionObserver/WithIntersectionObserver.js